export default "__VITE_ASSET__DRsvt9eH__"